import { useEffect, useRef, useState } from "react";
import s from "./ReportFilters.module.scss";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { GlobalPeriodChooser, StructureHeader } from "src/main";
import { PortfolioDTOWithDetails } from "@iliotech/generated-api";
import { PortfolioDTOWithDetailsV3RiskAssetViewEnum } from "@iliotech/generated-api-v3";
import { useGlobalPeriod, usePortfolioAllocation } from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useClickAway } from "react-use";
import { ReportOrientationChanger } from "../ReportOrientationChanger/ReportOrientationChanger";

interface IProps {
  riskAssetView: PortfolioDTOWithDetailsV3RiskAssetViewEnum;
  inceptionDate: string;
}

export const ReportFilters = ({ riskAssetView, inceptionDate }: IProps) => {
  const [expanded, setExpanded] = useState(false);
  const { portfolioId } = useParams();
  const allocations = usePortfolioAllocation(portfolioId!);

  const anchor = useRef(null);

  useClickAway(anchor, (e) => {
    if (expanded) {
      setExpanded(false);
    }
  });

  return (
    <div ref={anchor} id="report-filters" className={s.container}>
      <div onClick={() => setExpanded(!expanded)} className={s.title}>
        <span>Settings</span>
        {expanded ? <BiChevronUp /> : <BiChevronDown />}
      </div>
      {expanded && (
        <div className={s.innerContainer}>
          <div className={s.structureHeaderWrapper}>
            <StructureHeader
              riskAssetView={riskAssetView}
              {...allocations?.data?.data}
            />
          </div>
          <GlobalPeriodChooser
            appendTo="report-filters"
            inceptionDateOverride={inceptionDate}
          />
          <ReportOrientationChanger />
        </div>
      )}
    </div>
  );
};
